<template>
  <v-container fluid grid-list-md fill-height class="bgBlue">
    <v-layout row wrap text-xs-center>
      <MobileApp />
    </v-layout>
  </v-container>
</template>

<script>
import MobileApp from "@/views/mobile/App";

export default {
  components: {
    MobileApp
  },
  data: () => ({
    loginShow: false
  }),

  method: () => ({})
};
</script>
